import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, IconButton, Loader, useToggle, Tooltip } from '@treezor/design-system';

import { IWallet } from '@/features/wallets/store/models/wallet.model';
import { useWalletMenu } from '@/features/wallets/hooks/useWalletMenu';
import { TDashboardConfigSettingsWalletsOptions } from '@/features/wallets/types/index';
import { IAgentProfileWallet } from '@/features/wallets/store/types/agent-wallets.types';

import { IUser } from '@/features/user/store/user.model';

interface IWalletMenuProps {
  wallet: IWallet;
  user: number | IUser;
  options?: TDashboardConfigSettingsWalletsOptions[];
  profileWallet?: IAgentProfileWallet;
}

export const WalletMenu = ({ wallet, user, options, profileWallet }: IWalletMenuProps) => {
  const iconButtonRef = useRef<HTMLButtonElement & HTMLAnchorElement>(null);
  const { t } = useTranslation();

  const [isDropdownOpen, toggleDropdown] = useToggle(false);
  const { WalletDeactivationDialog, walletActions, isDisabled, isLoading } = useWalletMenu(
    wallet,
    user,
    options,
    toggleDropdown,
    profileWallet,
  );

  return (
    <>
      <div className="relative" data-testid={`${wallet.walletId}-options`}>
        <div className="w-7 h-7 flex flex-col justify-center items-center relative">
          {isLoading ? (
            <Loader className="absolute" size={'s'} color="rgb(0 67 178 / 0.5)" />
          ) : isDisabled ? (
            <Tooltip messageContent={t('pages.currentProfiles.wallets.actions.tooltip.noActions')}>
              <IconButton icon="more_vert" variant="secondary" disabled />
            </Tooltip>
          ) : (
            <IconButton
              ref={iconButtonRef}
              icon="more_vert"
              variant="secondary"
              isActive={isDropdownOpen}
              onClick={toggleDropdown}
            />
          )}
        </div>
        {isDropdownOpen && (
          <Dropdown
            items={walletActions}
            onClose={toggleDropdown}
            parentRef={iconButtonRef}
            overflow
            closeOnSelect={true}
          />
        )}
      </div>
      <WalletDeactivationDialog.ConfirmationDialog />
    </>
  );
};
